import Keyboard from "react-simple-keyboard";
import "react-simple-keyboard/build/css/index.css";

// Teclado na tela do totem: "alpha" para nome, mesa e busca; "numeric" para
// CPF/CNPJ. É não controlado: guarda o próprio texto e avisa cada mudança.
const LAYOUTS = {
  alpha: {
    inputName: "name",
    layout: [
      "1 2 3 4 5 6 7 8 9 0 {bksp}",
      "q w e r t y u i o p",
      "a s d f g h j k l",
      "z x c v b n m",
      "{space}",
    ],
    keyClass: "totem-keyboard",
    keys: "1 2 3 4 5 6 7 8 9 0 q w e r t y u i o p a s d f g h j k l z x c v b n m {bksp} {space}",
    wideKeys: "{bksp} {space}",
  },
  numeric: {
    inputName: "cpfcnpj",
    layout: ["1 2 3", "4 5 6", "7 8 9", "0 {bksp}"],
    keyClass: "totem-numpad",
    keys: "1 2 3 4 5 6 7 8 9 0 {bksp}",
    wideKeys: "{bksp}",
  },
};

export default function TotemKeyboard({ layout = "alpha", onKeyboardChange }) {
  const config = LAYOUTS[layout];

  return (
    <Keyboard
      inputName={config.inputName}
      theme={"hg-theme-default hg-layout-default totem"}
      onChange={onKeyboardChange}
      layout={{ default: config.layout }}
      display={{
        "{bksp}": "✖️",
        "{space}": " ",
      }}
      buttonTheme={[
        { class: config.keyClass, buttons: config.keys },
        { class: "totem-back-space", buttons: config.wideKeys },
      ]}
      maxLength={14}
    />
  );
}
